import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  mainPaper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '@media (min-width: 1024px)': {
      margin: '16px 24px',
      padding: '24px',
      rowGap: '24px',
    },
  },
  detailsMapGrid: {
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    width: '100%',
    height: 'fit-content',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      gap: '0px',
    },
  },

  mapGrid: {
    backgroundColor: 'black',
    width: '40%',
    minWidth: '400px',
    height: '348px',
    '@media (max-width: 1024px)': {
      width: '100%',
      minWidth: '0px',
      height: '322px',
    },
  },
  detailsContent: {
    display: 'flex',
    width: '100',
    margin: '0px',
    flexDirection: 'column',
    rowGap: '24px',
    '@media (max-width: 1024px)': {
      width: 'auto',
      margin: '24px 16px',
    },
  },
  detailsContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '6px',
    padding: '0px 8px 0px 0px',
    width: '100%',
  },
  detailsContentBlueContainer: {
    display: 'flex',
    backgroundColor: theme.evPalette.ocean[100],
    flexDirection: 'column',
    padding: '10px',
    width: '100%',
    borderRadius: '4px',
  },
  detailsContentTitleText: {
    textTransform: 'uppercase',
  },
  clickable: {
    textDecoration: 'none',
  },
  infoText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '@media (max-width: 1024px)': {
      padding: '0px 16px 16px 16px',
    },
  },
  warningAlert: {
    backgroundColor: theme.evPalette.mango[100],
    borderBottom: `1px solid ${theme.evPalette.mango[700]}`,
  },
  alert: {
    padding: '0px 24px',
    borderRadius: '1px',
    '@media (min-width: 1024px)': {
      padding: '0px 24px',
      borderBottom: `1px solid ${theme.evPalette.mango[700]}`,
      borderRadius: '4px',
    },
  },
  alertMsg: {
    display: 'flex',
    flexDirection: 'column',
    color: theme.evPalette.charcoal[900],
    gap: '8px',
    fontSize: '14px',
    '&>.title': {
      lineHeight: '19px',
    },
    '&>.message': {
      lineHeight: '18px',
      '&>a': {
        color: theme.evPalette.ocean[700],
      },
    },
    '@media (min-width: 1024px)': {
      gap: '8px',
      '&>.title': {
        lineHeight: '27px',
      },
      '&>.message': {
        lineHeight: '19px',
      },
    },
  },
  warningAlertIcon: {
    padding: '12px 0px',
    '& svg': { color: theme.evPalette.mango[700] },
  },
  closeBtn: { alignItems: 'flex-start' },
  statusChip: {
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    height: 'unset',
    padding: '2px',
    width: 'fit-content',
    borderRadius: '12px',
  },
  completed: {
    backgroundColor: theme.evPalette.lime[100],
    color: theme.evPalette.lime[800],
  },
  closed: {
    backgroundColor: theme.evPalette.charcoal[400],
    color: theme.evPalette.charcoal[800],
  },
  inProcess: {
    backgroundColor: theme.evPalette.mango[100],
    color: theme.evPalette.mango[800],
  },
  created: {
    backgroundColor: theme.evPalette.mango[100],
    color: theme.evPalette.mango[800],
  },
  actionNeeded: {
    backgroundColor: theme.evPalette.raspberry[100],
    color: theme.evPalette.raspberry[700],
  },
  checkEmail: {
    backgroundColor: theme.evPalette.raspberry[700],
    color: theme.evPalette.raspberry[100],
  },
}));
